import React from 'react';
import PropTypes from 'prop-types';
import './Contact.css';

const Contact = () => (
  <section id="contact" className="min-h-screen bg-cover bg-fixed bg-right bg-black">
    <div className="lg:w-1024 md:w-full sm:w-full mx-auto flex px-8 py-24 flex-col text-white">
      <div className="w-full mb-8 lg:w-1/2 flex flex-col items-start text-left">
        <h1 className="w-full text-2xl sm:text-4xl font-bold title-font mb-4">
          Contact
        </h1>
        <p className="text-lg tracking-widest">Universidad Carlos III de Madrid,</p>
        <p className="text-lg tracking-widest">Dept. of Computer Science</p>
        <p className="text-lg tracking-widest">Avda. de la Universidad, 30, 28911,</p>
        <p className="text-lg tracking-widest">Leganés (Madrid), Spain</p>
        <br />
        <p className="text-lg tracking-widest"><strong>office</strong>: 2.2.B.15 </p>
        <p className="text-lg tracking-widest"><strong>phone</strong>: +34 91624 9415</p>
        <p className="text-lg tracking-widest"><strong>email</strong>: abellucc [at] inf dot uc3m dot es</p>
      </div>
      <div className="w-full">
      <iframe className="w-full" 
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3041.460346634022!2d-3.7691239837484!3d40.332132879374896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd41898badeb13f5%3A0xff1f21ccb66349e9!2sEdificio%20Sabatini%20(antiguo%20Cuartel%20de%20Saboya)!5e0!3m2!1ses!2ses!4v1646044997176!5m2!1ses!2ses" 
      width="600" 
      height="450" 
      allowfullscreen="" 
      loading="lazy">
        </iframe>
        {/*<div >
          <iframe className="w-full sm:h-320"
            id="gmap_canvas"
            src="https://maps.google.com/maps?q=40.332260824530415,%20-3.7669056903790312&t=&z=17&ie=UTF8&iwloc=&output=embed"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0">
          </iframe>
        </div>*/}
      </div>
      </div>
  </section>
);

Contact.propTypes = {};

Contact.defaultProps = {};

export default Contact;
